import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { graphqlRestClient } from '../bk-web-app';
import ApplyRules from './applyRules';

const ApplyRulesButton = (props: { clientId: string }) => {
  const { clientId } = props;
  return (
    <ApolloProvider client={graphqlRestClient}>
      <ApplyRules clientId={clientId} />
    </ApolloProvider>
  );
};

export default ApplyRulesButton;
